import { Element } from 'domhandler';

import { ALLOWED_ATTR_CHARS, ALLOWED_ATTRS, YOUTUBE_BASE_PATH, YOUTUBE_PLAYER_SETTINGS } from '../../constants';
import type { RichMediaTagTransformer } from '../../types';
import { validateString } from '../../validateString';

export const decodeTransformer: RichMediaTagTransformer = () => {
	const shouldTransformElement = (element: Element): boolean =>
		element.attributes.find((el) => el.name === 'data-type')?.value === 'youtube';

	const transformTagFn = (element: Element): Element => {
		if (!shouldTransformElement(element)) return element;
		const newTagName = 'iframe';
		const newAttributes = {
			...element.attributes.reduce<Record<string, string>>((newAttrs, attribute) => {
				const matchedName = ALLOWED_ATTRS.find((attrName) => `data-${attrName}` === attribute.name);
				if (matchedName && validateString(attribute.value, ALLOWED_ATTR_CHARS[matchedName])) {
					return {
						...newAttrs,
						[matchedName]:
							matchedName === 'src'
								? `${YOUTUBE_BASE_PATH}/${attribute.value}?${YOUTUBE_PLAYER_SETTINGS}`
								: attribute.value,
					};
				}
				return newAttrs;
			}, {}),
		};
		return new Element(newTagName, newAttributes, element.children);
	};

	const transformer = { tagName: 'change-media', transformTagFn };

	return { transformer };
};
